/** 将外部选择上限归一化为可安全参与比较的非负整数。 */
export function normalizeMaxSelectableCount(value?: number): number | undefined {
  if (!Number.isFinite(value)) return undefined;
  return Math.max(0, Math.floor(value as number));
}

/** 判断批量选择是否允许切换目标；已选项始终允许取消。 */
export function canToggleBatchAssetSelection(
  selectedIds: Set<string>,
  targetId: string,
  maxSelectableCount?: number,
): boolean {
  if (selectedIds.has(targetId)) return true;
  const normalizedLimit = normalizeMaxSelectableCount(maxSelectableCount);
  return normalizedLimit == null || selectedIds.size < normalizedLimit;
}

/** 在选择上限内切换素材选中态，达到上限时保持原 Set 引用以避免无效重渲。 */
export function toggleBatchAssetSelection(
  selectedIds: Set<string>,
  targetId: string,
  maxSelectableCount?: number,
): Set<string> {
  if (!canToggleBatchAssetSelection(selectedIds, targetId, maxSelectableCount)) {
    return selectedIds;
  }
  const next = new Set(selectedIds);
  if (next.has(targetId)) next.delete(targetId);
  else next.add(targetId);
  return next;
}
